export const LeftColumnText = `## Is this for you?

The Small Business Framework (SBF) helps both new and existing business owners to navigate the many aspects of setting up and running a successful business.

The SBF breaks down a business into four logical interconnected parts, each with its own subset of activities:
1. Owners Profile
2. Business Strategy
3. Marketing
4.Operations and Administration


The SBF is based on established fundamental business methodologies that have been simplified into easy to use and understandable business concepts.

It is scaleable and suitable for small and medium size businesses (1 person+).​

It is also flexible enough to suit all industries both products and services businesses​
`;
export const RightColumnText = `## How do you use it?

The SBF is interactive, guiding you step by step to enter information relevant for your business. You are then able to print it off into a 'Business Plan' format.

*Click on each heading below to learn more about each part.  You can also use the menu above to navigate.*`;

export const FirstSection = `
# What is it?

**The Small Business Framework (SBF) helps both new and existing business owners to navigate the many aspects of setting up and running a successful business.**

The SBF is **based on established and fundamental business principles** that have been simplified into easy to use and **understandable business concepts**.

The SBF **breaks down a business into four logical interconnected parts**, each with its own subset of activities:
​

1. Owners Profile (Top left)
2. Business Strategy (Top right)
3. Marketing (Bottom right)
4. Operations and Administration (Bottom Left)
`;

export const WhoShouldUseIt = `
# Who should use it?

The SBF is **targeted at entrepreneurs and business owners who are starting, or already running, a small enterprise.**

​It could be used by a **potential business owner** who has:

1.  Turned a skill into a product or service and chosen to work for themselves rather than for someone else.   ​
2. Conceived a fantastic idea but has no idea whether or not its commercially viable.

The SBF is:​
- Scalable to suit micro, small and medium size businesses. 
- Equally applicable for profit or not for profit enterprises
- Flexible enough to suit all industries and both products and services businesses​.
`;

export const HowToUseIt = `
# How do you use it?

Ultimately, a successful outcome is that the **SBF enables potential  business owners to build the confidence to start their own business.** It has been designed to be an **intuitive and interactive online portal** that can be used - and the information digested - at the user’s own pace.  Although there are already many self-help business sites online, the sheer quantum of information can be quite overwhelming even for experienced business people!  

The intent is that **the user works their way around the framework** starting with the Owners Profile quadrant – the premise being - who the owner is underpins everything else.  Once the user has completed this quadrant they can work through the other quadrants in the **logical and recommended order.**   

Although there is a recommended logical order, user’s also have the **flexibility to access all quadrants and components in any order they wish.**
`;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Data.ts